/**
 * Session-scoped registry that remembers navigation selection state per
 * arbitrary "scope" key (usually the route pathname of a tab). Entries
 * persist across component unmount/remount, but are cleared on app reload —
 * matching the durability the user actually wants for this UX state.
 */

export interface NavSnapshot {
  focusedNavIndex: number | null
  selectedIds: Set<string>
}

const registry = new Map<string, NavSnapshot>()

/** Returns a *copy* of the snapshot so callers can mutate freely. */
export function getNavSnapshot(scope: string): NavSnapshot | undefined {
  const snap = registry.get(scope)
  if (!snap) return undefined
  return {
    focusedNavIndex: snap.focusedNavIndex,
    selectedIds: new Set(snap.selectedIds),
  }
}

/** Stores a defensive copy so later mutations at the call site don't leak. */
export function setNavSnapshot(scope: string, snap: NavSnapshot): void {
  registry.set(scope, {
    focusedNavIndex: snap.focusedNavIndex,
    selectedIds: new Set(snap.selectedIds),
  })
}

/** Test-only: drop everything. */
export function clearAllNavSnapshots(): void {
  registry.clear()
}
